import PrivacyNotice from "./onboarding/PrivacyNotice";

export default function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: "600px", margin: "40px auto", padding: "0 20px" }}>
      <PrivacyNotice />
    </div>
  );
}
